<template>
	<div class="orderStatus">
		<back-to></back-to>
		<section class="explain">
			<h2>{{productList.StatusName}}</h2>
			<p>{{productList.StatusMsg}}</p>
			<label for="" @click="$router.push({ path: '/orderList',query:{'orderType':5}})">返回我的订单</label>
		</section>
		<section class="orderStatus-img">
			<img v-if="productList.StatusCode == 'Void'" :src="statusImg.Void" alt="">
			<img v-if="productList.StatusCode == 'Examine'" :src="statusImg.Examine" alt="">
			<img v-if="productList.StatusCode == 'OrderOut'" :src="statusImg.OrderOut" alt="">
			<img v-if="productList.StatusCode == 'Trip'" :src="statusImg.Trip" alt="">
			<img v-if="productList.StatusCode == 'Evaluate'" :src="statusImg.Evaluate" alt="">
			<img v-if="productList.StatusCode == 'Agree'" :src="statusImg.Agree" alt="">
			<img v-if="productList.StatusCode == 'Pay'" :src="statusImg.Pay" alt="">
			<img v-if="productList.StatusCode == 'Refunding'" :src="statusImg.Refunding" alt="">
			<img v-if="productList.StatusCode == 'Refund'" :src="statusImg.Refund" alt="">
			<img v-if="productList.StatusCode == 'Complete'" :src="statusImg.Complete" alt="">
			<img v-if="productList.StatusCode == 'OrderData'" :src="statusImg.OrderData" alt="">
		</section>
		<section class="orderStatus-info">
			<h2>产品信息</h2>
			<label for="" class="orderStatus-info_img">
				<p>{{productList.ProductName}}</p>
				<img src="https://m.sweetour.com/images/mini/icon-right.png" alt="">
			</label>
			<span class="orderStatus-info_con">
				<label for="" v-for="(item,index) in productList.DDinfo">
					<font>{{item[0][0]}}</font>
					<p>{{item[1][0]}}</p>
				</label>
				<label for="">
					<font>原价格</font>
					<p class="orgen">￥{{productList.Price01}}</p>
				</label>
				<label for="">
					<font>实付金额</font>
					<p class="orgen">￥{{productList.Price02}}</p>
				</label>
			</span>
			<h2>联系人信息</h2>
			<span class="orderStatus-info_con">
				<label for="">
					<font>姓名</font>
					<p>{{productList.ContactsName}}</p>
				</label>
				<label for="">
					<font>电话</font>
					<p>{{productList.ContactsPhone}}</p>
				</label>
				<label for="">
					<font>备注</font>
					<p>{{productList.Mark}}</p>
				</label>
			</span>
		</section>
		<section class="choiceBtn" v-if="ButtonsLength>0">
			<div class="choiceBtn-l" @click="gotoBUY(0)">{{productList.Buttons[0].ButtonText}}</div>
			<div class="choiceBtn-r" @click="gotoBUY(1)">{{productList.Buttons[1].ButtonText}}</div>
		</section>
		<!-- 提交订单成功 -->
		<van-popup class="orderShow " v-model="orderShow" round position="bottom">
			<img src="https://m.sweetour.com/img/public/order-canle.png" alt="">
			<label for="">
				<p class="oo-title-suc">{{ootitlesuc}}</p>
			</label>
			<span class="oo-btn" v-if="isqueding">
				<p class="oo-jump fl" @click='mycancel'>继续</p>
				<p class="oo-jump fl" @click='orderShow = false'>返回</p>
			</span>
			<span class="oo-btn" v-if="!isqueding">
				<p class="oo-jump fl" @click='$router.push({ path: "/" })'>确认</p>
			</span>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		formatTime
	} from '@/config/util'
	import BackTo from "@/components/BackTo";
	import {
		Toast
	} from 'vant'
	export default {
		name: 'orderStatus',
		components: {
			BackTo
		},
		data() {
			return {
				orderID: "",
				productList: [],
				statusImg: {
					Examine: "https://m.sweetour.com/img/orderDetails/Examine.png",
					OrderOut: "https://m.sweetour.com/img/orderDetails/OrderOut.png",
					Trip: "https://m.sweetour.com/img/orderDetails/Trip.png",
					Evaluate: "https://m.sweetour.com/img/orderDetails/Evaluate.png",
					Agree: "https://m.sweetour.com/img/orderDetails/Agree.png",
					Pay: "https://m.sweetour.com/img/orderDetails/Pay.png",
					Refunding: "https://m.sweetour.com/img/orderDetails/Refunding.png",
					Refund: "https://m.sweetour.com/img/orderDetails/Refund.png",
					Complete: "https://m.sweetour.com/img/orderDetails/Complete.png",
					Void: "https://m.sweetour.com/img/orderDetails/Void.png",
					OrderData: "https://m.sweetour.com/img/orderDetails/OrderOut.png"
				},
				orderShow: false,
				ootitlesuc: "正在取消订单！",
				isqueding: true,
				ButtonsLength: 0
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			this.orderID = this.$route.query.orderId
		},
		mounted() {
			this.getData()
		},
		methods: {
			getData() {
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/GetOrderInfo', {
						orderID: this.orderID
					}
				).then(res => {
					console.log(res)
					this.productList = res
					this.ButtonsLength = res.Buttons.length
				})
			},
			gotoBUY(e) {
				if (this.productList.Buttons[e].ButtonText == '取消订单') {
					this.orderShow = true
				} else if (this.productList.Buttons[e].ButtonText == '去支付' && this.productList.StatusCode == 'Pay') {
					// Toast("支付功能暂未开通")
					const toast = Toast.loading({
						duration: 0, // 持续展示 toast
						forbidClick: true,
						message: '支付中',
					});

					this.$post(
						this.$login + '/LST/CreateOrder', {
							'orderNo': this.productList.SerialNO,
							"userId": '' + this.userInfo.lstUserId,
							"returnUrl": 'https://lst.sweetour.com/orderStatus?orderId=' + this.orderID +
								'&orderType=' + this.$route.query.orderType + '&payTrue=true'
						}
					).then(res => {
						const url = res.py_URL
						window.location.href = url;
					})
				} else if (this.productList.Buttons[e].ButtonText == '完善资料' && this.productList.StatusCode ==
					'OrderData') {
					this.$router.push({
						path: '/call',
						query: {
							orderId: this.orderID
						}
					})
				} else if (this.productList.Buttons[e].ButtonText == '去评价' && this.productList.StatusCode == 'Evaluate') {
					Toast("daiwanshan")
				}
			},
			mycancel() {
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/CancelOrder', {
						orderID: this.orderID
					}
				).then(res => {
					this.ootitlesuc = "订单已取消"
					this.isqueding = false
				})
			}
		}
	}
</script>

<style scoped>
	.explain {
		width: 100%;
		padding: 10px 48px 50px 48px;
		box-sizing: border-box;
	}

	.explain h2 {
		color: #6464ff;
		font-size: 56px;
	}

	.explain p {
		margin-top: 48px;
		font-size: 32px;
	}

	.explain label {
		margin-top: 48px;
		font-size: 35px;
		color: #ff6d00;
		display: inline-block;
	}

	.orderStatus-img img {
		width: 100%;
	}

	.orderStatus-info {
		width: 100%;
		padding: 48px;
		box-sizing: border-box;
		padding-bottom: 160px;
	}

	.orderStatus-info h2 {
		font-size: 36px;
		color: #333;
	}

	.orderStatus-info_img {
		background: #f8f8f8;
		margin-top: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #333;
		font-size: 32px;
		padding: 24px;
		box-sizing: border-box;
	}

	.orderStatus-info_img img {
		width: 30px;
		height: 30px;
	}

	.orderStatus-info_con {
		width: 100%;
		margin-top: 48px;
		display: block;
	}

	.orderStatus-info_con label {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 40px;
	}

	.orderStatus-info_con font {
		font-size: 26px;
		color: #666;
	}

	.orderStatus-info_con p {
		font-size: 26px;
		color: #333;
		width: 450px;
		text-align: right;
	}

	.orgen {
		color: #ff6d00 !important;
	}

	.choiceBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 96px;
		border-top: 1px solid #e5e4e3;
		background-color: #fff;
	}

	.choiceBtn div {
		height: 96px;
		display: flex;
		align-items: center;
		flex: 1;
		justify-content: center;
	}

	.choiceBtn-r {
		background: #ff6d00;
		font-size: 28px;
		color: #fff;
		border: 0;

	}

	.choiceBtn-l {
		font-size: 28px;
		display: inline-block;
		box-sizing: border-box;
		color: #000;
	}

	.orderShow {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		padding: 30px 0;
		height: 400px;
	}

	.orderShow img {
		height: 116px;
		width: 116px;
	}



	.oo-title-suc {
		font-size: 36px;
		color: #666;
		font-weight: bolder;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}


	.oo-btn {
		display: flex;
		align-items: center;
		justify-content: space-around;
		width: 100%;
	}


	.oo-jump {
		background: #f7f8f8;
		color: #333;
		border: 2px solid #b5b5b6;
		margin-left: 6px;
		width: 260px;
		height: 76px;
		line-height: 76px;
		text-align: center;
		font-size: 32px;
		border-radius: 5px;
	}
</style>
